import { render, staticRenderFns } from "./UiField.vue?vue&type=template&id=34f645c3&scoped=true"
import script from "./UiField.vue?vue&type=script&lang=js"
export * from "./UiField.vue?vue&type=script&lang=js"
import style0 from "./UiField.vue?vue&type=style&index=0&id=34f645c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f645c3",
  null
  
)

export default component.exports